/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
const Q_buff_ally = require('./Q_buff_ally');
const Q_ally_no_option = require('./Q_ally_no_option');
const UseAbility = require('../UseAbility');

const Q_ally_no_bless = function (actor, battleState) {
  const node = new Q_buff_ally('bless', actor, battleState);

  node.branches[node.NO] = new Q_ally_no_option(actor, battleState);
  node.branches[node.YES] = new UseAbility(actor, 'bless');

  return node;
};
module.exports = Q_ally_no_bless;
